<template>
  <div class="mt-2">
    <section-title title="Configuración de Secciones" has-line />
    <sections
      ref="sections"
      v-model="model.sections"
      :question-types="questionTypes"
      :is-read-only="isReadOnly"
    />
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import Sections from './questionnaire/Sections';

export default {
  name: 'Questionnaire',
  components: {
    SectionTitle,
    Sections,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    questionTypes: {
      type: Array,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async validate() {
      if (!this.model.sections.length) return true;
      return await this.$refs['sections'].validate();
    },
  },
};
</script>
